<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    光明站<br>
站点介绍<br>
光明站位于规划荔林路至新民横二街之间的光明大道北段，呈南北向敷设。北接科学公园站，南接光明大街站<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:41	23:21	6号线	3分24秒	6分20秒<br>
松岗	06:04	23:50	6号线	3分24秒	6分20秒<br>
光明	06:35	23:30	66号线	6分52秒	8-10分钟<br>
深理工	--	--	66号线	6分52秒	8-10分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:41	23:21	6号线	4分45秒	6分钟<br>
松岗	06:04	23:50	6号线	4分45秒	6分钟<br>
光明	06:35	23:30	66号线	6分52秒	8-10分钟<br>
深理工	--	--	66号线	6分52秒	8-10分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:41	00:21	6号线	4分45秒	6分钟<br>
松岗	06:04	00:50	6号线	4分45秒	6分钟<br>
光明	06:35	00:30	66号线	6分52秒	8-11分钟<br>
深理工	--	--	66号线	6分52秒	8-11分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
新健兴科技工业园、翠湖公园<br><br>
C出入口:<br>
深圳市第二职业技术学校<br>
公交换乘信息<br>

</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "liuhaoxianzhixian",
          title: "6号线支线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>